const CheckCircleSmall = ({ color }: { color?: string }) => (
    <svg width="24" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_813_15393)">
            <path d="M5 8.33325L7 10.3333L11.6667 5.66659" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.33366 14.6666C12.0156 14.6666 15.0003 11.6818 15.0003 7.99992C15.0003 4.31802 12.0156 1.33325 8.33366 1.33325C4.65176 1.33325 1.66699 4.31802 1.66699 7.99992C1.66699 11.6818 4.65176 14.6666 8.33366 14.6666Z" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_813_15393">
                <rect width="16" height="16" fill="white" transform="translate(0.333496)" />
            </clipPath>
        </defs>
    </svg>
);

export default CheckCircleSmall;
